const firebaseConfig = {
    apiKey: "AIzaSyCvpkLOkCGi411rm_TOO-2Wn1G0lDzsW5M",
    authDomain: "dental-care-clinic.firebaseapp.com",
    projectId: "dental-care-clinic",
    storageBucket: "dental-care-clinic.appspot.com",
    messagingSenderId: "198722467284",
    appId: "1:198722467284:web:43519bfabe743ff98e5241"
  };

  export default firebaseConfig;